import React, { Component } from 'react';
import moment from 'moment';
import {
     Button, Modal, ModalHeader, ModalBody, ModalFooter,
     UncontrolledTooltip,
} from 'reactstrap';

import api from '../../../api/api';
import apifunctions from '../../../api/functions.js';

class ModalEnvioMails extends Component {
     constructor(props) {
          super(props);
          this.state = {
               clientes:[],
               idsEnviarMail:[],
               msg:"",
               btnConfirmaDisabled:false,
               showModal:false,
          };
     }

     loadData(){
          let url = api.MailsDeudores;
          let filters = [];
          if(this.props.filtros){
               if(this.props.filtros.desde && this.props.filtros.hasta) filters.push(`fecha_range=${moment(this.props.filtros.desde).format("Y-M-D")},${moment(this.props.filtros.hasta).format("Y-M-D")}`);
               if(this.props.filtros.loteo_id) filters.push("loteo_id="+this.props.filtros.loteo_id);
          }
          const failCallback = () => this.setState({
               clientes:[],
               msg:"",
               idsEnviarMail:[],
               btnConfirmaDisabled:false,
          });
          const successCallback = (resp) => {
               if (resp && resp.data && resp.data.success){
                    this.setState({
                         clientes:resp.data.data ? resp.data.data : [],
                         idsEnviarMail:[],
                         msg:resp.data.msg,
                         btnConfirmaDisabled:false,
                    });
               }
               else this.setState({
                    clientes:[],
                    msg:"",
                    idsEnviarMail:[],
                    btnConfirmaDisabled:false,
               });
          }
          apifunctions.get(url, null, null, {filters:filters}, successCallback, failCallback, failCallback);
     }

     componentDidMount(){
          this.loadData();
     }

     componentDidUpdate(prevProps, prevState){
          if(prevState.showModal == false && this.state.showModal == true) this.loadData();
     }

     componentWillReceiveProps(nextProps){
          this.loadData();
     }

     sendData(evt){
          this.setState(
               {btnConfirmaDisabled:true},
               ()=>{
                    const failCallback = () => this.setState({
                         clientes:[],
                         idsEnviarMail:[],
                         msg:"",
                         showModal:false,
                         btnConfirmaDisabled:false,
                    });
                    const successCallback = (resp) => {
                         if (resp && resp.data && resp.data.success){
                              this.setState({
                                   clientes:[],
                                   idsEnviarMail:[],
                                   showModal:false,
                                   msg:"",
                                   btnConfirmaDisabled:false,
                              });
                         }
                         else this.setState({
                              clientes:[],
                              idsEnviarMail:[],
                              showModal:false,
                              msg:"",
                              btnConfirmaDisabled:false,
                         });
                    }

                    apifunctions.post(api.EnviarMailMorosos, null, {ids:this.state.idsEnviarMail}, successCallback, failCallback, failCallback);
               }
          );
     }

     updateIdsEnviar(evt, id){
          evt.preventDefault();
          this.setState(prevState=>{
               let {idsEnviarMail} = prevState;
               if(idsEnviarMail.filter(item=>item==id).length > 0){
                    idsEnviarMail=idsEnviarMail.filter(item=>item!=id);
               }
               else{
                    idsEnviarMail.push(id);
               }
               prevState.idsEnviarMail = idsEnviarMail;
               return prevState;
          });
     }

     asignarTodosIdsEnviar(){
          this.setState(prevState=>{
               let {clientes} = prevState;
               prevState.idsEnviarMail = clientes.map(item=>item.id);
               return prevState;
          });
     }

     asignarNingunIdsEnviar(){
          this.setState(prevState=>{
               prevState.idsEnviarMail = [];
               return prevState;
          });
     }

     render() {
          const {
               clientes, idsEnviarMail, msg,
               showModal, btnConfirmaDisabled,
          } = this.state;

          const toggle = () => this.setState({showModal:!showModal});
          const className = "ui-paradigma-modal ui-paradigma-modal-wide ui-mail-modal";

          return (
               <React.Fragment>
               <button onClick={toggle} id="UncontrolledTooltipSendmails" className="icon btn btn-sm h-100 ui-icon-action"><i className="fa fa-envelope-o fa-lg"></i></button>
               <UncontrolledTooltip placement="bottom" target="UncontrolledTooltipSendmails">
               Enviar Mails
               </UncontrolledTooltip>

               <Modal size="lg" isOpen={showModal} centered toggle={toggle} className={className}>
               <ModalHeader toggle={toggle}>Compradores a Notificar</ModalHeader>
               <ModalBody>
               {
                   clientes.length > 0 ?
                    <React.Fragment>
                    <div className="ui-mail-actions">
                         <Button className="ui-btn-primary" onClick={()=>this.asignarTodosIdsEnviar()}>Marcar Todos</Button>
                         <Button className="ui-btn-cancel" onClick={()=>this.asignarNingunIdsEnviar()}>Desmarcar Todos</Button>
                    </div>

                    <div className="ui-mail-list">
                         <div className="ui-mail-list-header">
                              <span>Nombre</span>
                              <span>Email</span>
                              <span>Último Envío</span>
                              <span>Enviar</span>
                         </div>
                    {
                         clientes.map((item,index)=>(
                              <button
                                   type="button"
                                   key={item.id}
                                   onClick={(evt)=>this.updateIdsEnviar(evt, item.id)}
                                   className={idsEnviarMail.filter(elem=>elem == item.id).length > 0 ? "ui-mail-list-row is-selected" : "ui-mail-list-row"}
                              >
                                   <span>{item.nombre}</span>
                                   <span>{item.email}</span>
                                   <span>{item.fechaUltimoEnvio}</span>
                                   <span>
                                   {
                                        idsEnviarMail.filter(elem=>elem == item.id).length > 0 ?
                                        <span className="ui-mail-selected">
                                        <i className="fa fa-share" aria-hidden="true"></i>
                                        <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                        </span>
                                        :
                                        ""
                                   }
                                   </span>
                            </button>
                         ))
                    }
                    </div>
                    </React.Fragment>
                    :
                    <p className="ui-empty-state">{msg}</p>
               }
               </ModalBody>
               <ModalFooter>
               {
                    clientes.length > 0 && <Button disabled={btnConfirmaDisabled} onClick={()=>this.sendData()} className="ui-btn-primary">Confirmar</Button>
               }
               <Button onClick={toggle} className="ui-btn-cancel">Cerrar</Button>
               </ModalFooter>
               </Modal>
               </React.Fragment>
          );
     }
}

export default ModalEnvioMails;



// WEBPACK FOOTER //
// ./src/views/Servicios/EstadoGral/ModalEnvioMails.js